import { PlusCircleFilled } from "@ant-design/icons";
import {
  Card,
  Col,
  message,
  Row,
  Select,
  Form,
  Input,
  InputNumber,
  Button,
  Collapse,
} from "antd";
import React, { useState } from "react";
import { TypeIva } from "../../api/utils";
import { useProductStore, ReloadCatalogButton } from "./LayoutProducto";
import { ContableItems } from "./ContableItems";

export const productStore = 1;
const { Option } = Select;

export const SectionTitle = ({ children }) => (
  <h3
    style={{
      fontSize: "16px",
      fontWeight: 500,
      marginBottom: "16px",
      color: "#555",
    }}
  >
    {children}
  </h3>
);

export const ProductSimple = ({ addProductSimple }) => {
  const producto = useProductStore();
  const accountingMissing = [0, 1, 2, 3, 4].some(
    (i) => !producto.data.ParametrizacionContableProducto?.[i]?.NumeroCuenta
  );
  const [accountingOpen, setAccountingOpen] = useState(accountingMissing);

  const onFinish = () => {
    producto.setData({ productstore: productStore });
    addProductSimple(productStore);
  };

  const onFinishFailed = (errorInfo) => {
    // Si falta una cuenta contable, abrir el panel para que el error sea visible
    if (errorInfo.errorFields.some((f) => String(f.name[0]).startsWith("cat"))) {
      setAccountingOpen(true);
    }
    message.info("Por favor complete todos los campos obligatorios");
  };

  return (
    <Row justify="center" style={{ marginTop: "5px", width: "100%" }}>
      <div style={{ width: "100%" }}>
        <div className="site-card-border-less-wrapper" style={{ width: "100%" }}>
          <Card
            hoverable
            bordered
            title="Detalles del producto"
            style={{
              borderRadius: "12px",
              width: "100%",
              margin: "5px 0",
            }}
          >
            <Form
              name="basic"
              layout="vertical" // Labels arriba de los campos
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              scrollToFirstError
              autoComplete="off"
              initialValues={{
                Codigo: producto.data.Codigo,
                IdCategoria: producto.data.IdCategoria,
                IdSubCategoria: producto.data.IdSubCategoria,
                IdMarca: producto.data.IdMarca,
                Descripcion: producto.data.Descripcion,
                PrecioVentaConIva1: producto.data.PrecioVentaConIva1,
                PorcentajeIva: producto.data.PorcentajeIva,
                cat0: producto.data.ParametrizacionContableProducto?.[0]
                  ?.NumeroCuenta,
                cat1: producto.data.ParametrizacionContableProducto?.[1]
                  ?.NumeroCuenta,
                cat2: producto.data.ParametrizacionContableProducto?.[2]
                  ?.NumeroCuenta,
                cat3: producto.data.ParametrizacionContableProducto?.[3]
                  ?.NumeroCuenta,
                cat4: producto.data.ParametrizacionContableProducto?.[4]
                  ?.NumeroCuenta,
                weight: producto.data.weight,
              }}
            >
              <div style={{ marginBottom: "32px" }}>
                <SectionTitle>Información Básica</SectionTitle>
                <Row
                  gutter={[24, 16]}
                  style={{
                    marginLeft: "-12px",
                    marginRight: "-12px",
                    rowGap: "0px",
                  }}
                >
                  <Col xs={24} lg={12}>
                    <Form.Item
                      label="Código de Referencia"
                      name="Codigo"
                      rules={[
                        {
                          required: false,
                          message: "Digita la referencia del producto",
                        },
                      ]}
                      tooltip="Código único para identificar el producto (opcional)"
                    >
                      <Input
                        placeholder="Digita el código de referencia del producto"
                        maxLength={45}
                        onChange={(value) =>
                          producto.setData({ Codigo: value.target.value })
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} lg={12}>
                    <Form.Item
                      label="Nombre del Producto"
                      name="Descripcion"
                      rules={[
                        {
                          required: true,
                          message: "Digite el nombre del producto",
                        },
                      ]}
                      tooltip="Nombre descriptivo del producto"
                    >
                      <Input
                        placeholder="Ej: Camiseta de Algodón"
                        onChange={(value) =>
                          producto.setData({ Descripcion: value.target.value })
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} lg={12}>
                    <Form.Item
                      name="IdCategoria"
                      label="Categoría"
                      rules={[
                        { required: true, message: "Selecciona una categoría" },
                      ]}
                      tooltip="Selecciona la categoría principal del producto"
                    >
                      <Select
                        onChange={(value) =>
                          producto.setData({
                            IdCategoria: value,
                            Categoria: producto.knowName(
                              value,
                              producto.categorys
                            ),
                          })
                        }
                        placeholder="Selecciona una categoría"
                        allowClear
                        showSearch
                        style={{ width: "100%" }}
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                          optionA.children
                            .toLowerCase()
                            .localeCompare(optionB.children.toLowerCase())
                        }
                      >
                        {producto.categorys.map((category) => (
                          <Option key={category.id} value={category.id}>
                            {category.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} lg={12}>
                    <Form.Item
                      name="IdSubCategoria"
                      label="Subcategoría"
                      rules={[
                        {
                          required: true,
                          message: "Selecciona una subcategoría",
                        },
                      ]}
                      tooltip="Selecciona la subcategoría del producto"
                    >
                      <Select
                        onChange={(value) =>
                          producto.setData({
                            IdSubCategoria: value,
                            SubCategoria: producto.knowName(
                              value,
                              producto.categorys
                            ),
                          })
                        }
                        placeholder="Selecciona una subcategoría"
                        allowClear
                        showSearch
                        style={{ width: "100%" }}
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                          optionA.children
                            .toLowerCase()
                            .localeCompare(optionB.children.toLowerCase())
                        }
                      >
                        {producto.categorys.map((category) => (
                          <Option key={category.id} value={category.id}>
                            {category.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} lg={12}>
                  <Form.Item
                  name="IdMarca"
                  label="Marca"
                  tooltip="Selecciona una marca (opcional)"
                >
                  <Select
                    onChange={(value) => {
                      const selectedBrand = producto.brands.find((b) => b.id === value);
                      producto.setData({
                        IdMarca: value,
                        Marca: selectedBrand?.name,
                        tags: selectedBrand?.name ? [selectedBrand.name] : [],
                      });
                    }}
                    placeholder="Selecciona una marca"
                    allowClear
                    showSearch
                    style={{ width: "100%" }}
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    filterSort={(optionA, optionB) =>
                      optionA.children
                        .toLowerCase()
                        .localeCompare(optionB.children.toLowerCase())
                    }
                  >
                    {producto.brands.map((brand) => (
                      <Option key={brand.id} value={brand.id}>
                        {brand.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>

                  </Col>
                  <Col xs={24} lg={12}>
                    <Form.Item label=" " colon={false}>
                      <ReloadCatalogButton />
                    </Form.Item>
                  </Col>
                </Row>
              </div>

              <div style={{ marginBottom: "24px" }}>
                <SectionTitle>Detalles Contables</SectionTitle>
                <Collapse
                  activeKey={accountingOpen ? ["contable"] : []}
                  onChange={(keys) => setAccountingOpen(keys.length > 0)}
                  style={{ background: "#fafafa" }}
                >
                  <Collapse.Panel
                    key="contable"
                    forceRender
                    header={
                      accountingMissing
                        ? "Faltan cuentas por asignar: revisa la parametrización contable"
                        : "Parametrización contable cargada: clic para revisar o cambiar"
                    }
                  >
                    <p style={{ color: "#666" }}>
                      Cada producto necesita su parametrización contable para un
                      correcto registro financiero y control de inventario.
                    </p>
                    <ContableItems />
                  </Collapse.Panel>
                </Collapse>
              </div>

              <div style={{ marginBottom: "24px" }}>
                <SectionTitle>Precio e impuestos</SectionTitle>
                <Row gutter={[24, 0]}>
                  <Col xs={24} md={12}>
                    <Form.Item
                      label="Precio de Venta"
                      name="PrecioVentaConIva1"
                      rules={[
                        {
                          required: true,
                          message: "Digite el precio de venta",
                        },
                      ]}
                      tooltip="Precio de venta al público (incluye IVA)"
                    >
                      <InputNumber
                        style={{ width: "100%" }}
                        min={0}
                        precision={0}
                        placeholder="Ej: 200.000"
                        formatter={(value) =>
                          `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                        }
                        parser={(value) => value.replace(/\$\s?|\.+/g, "")}
                        onChange={(value) =>
                          producto.setData({
                            PrecioVentaConIva1: value,
                            PrecioVentaConIva2: value,
                            PrecioVentaConIva3: value,
                          })
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12}>
                    <Form.Item
                      name="PorcentajeIva"
                      label="Porcentaje IVA"
                      rules={[
                        {
                          required: true,
                          message: "Selecciona un porcentaje IVA",
                        },
                      ]}
                      tooltip="Selecciona el porcentaje de IVA aplicable"
                    >
                      <Select
                        onChange={(value) =>
                          producto.setData({ PorcentajeIva: value })
                        }
                        placeholder="Selecciona el IVA"
                        allowClear
                        style={{ width: "100%" }}
                      >
                        {TypeIva.map((typeiva) => (
                          <Option key={typeiva.Codigo} value={typeiva.Valor}>
                            {typeiva.Descripcion}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
              </div>

              <div style={{ marginBottom: "24px" }}>
                <SectionTitle>Peso y dimensiones</SectionTitle>
                <Row gutter={[16, 0]}>
                  <Col xs={12} lg={6}>
                    <Form.Item
                      label="Peso"
                      name="weight"
                      rules={[
                        { required: true, message: "Digite el peso del producto" },
                      ]}
                      tooltip="Peso del producto en kilogramos (ej: 1 o 0.3)"
                    >
                      <InputNumber
                        stringMode
                        min={0}
                        step={0.1}
                        style={{ width: "100%" }}
                        placeholder="Ej: 0.3"
                        addonAfter="kg"
                        onChange={(value) =>
                          producto.setData({ weight: value })
                        }
                      />
                    </Form.Item>
                  </Col>
                  {[
                    ["length", "Largo", "Ej: 10"],
                    ["width", "Ancho", "Ej: 5"],
                    ["height", "Alto", "Ej: 2"],
                  ].map(([field, label, placeholder]) => (
                    <Col xs={12} lg={6} key={field}>
                      <Form.Item
                        label={label}
                        name={field}
                        rules={[
                          { required: true, message: `Digita el ${label.toLowerCase()}` },
                        ]}
                      >
                        <InputNumber
                          stringMode
                          min={0}
                          style={{ width: "100%" }}
                          placeholder={placeholder}
                          addonAfter="cm"
                          onChange={(value) =>
                            producto.setData({
                              dimensions: {
                                ...producto.data.dimensions,
                                [field]: value,
                              },
                            })
                          }
                        />
                      </Form.Item>
                    </Col>
                  ))}
                </Row>
              </div>

              <div
                style={{
                  position: "sticky",
                  bottom: 0,
                  zIndex: 10,
                  background: "#fff",
                  borderTop: "1px solid #f0f0f0",
                  padding: "12px 0",
                  textAlign: "center",
                }}
              >
                <Button
                  type="primary"
                  htmlType="submit"
                  shape="round"
                  size="large"
                  icon={<PlusCircleFilled />}
                  style={{ padding: "0 32px", height: "48px", fontWeight: 500 }}
                >
                  Crear Producto
                </Button>
              </div>
            </Form>
          </Card>
        </div>
      </div>
    </Row>
  );
};
